<template>
  <div style="width: 100%">
    <el-table :data="robotlist" border style="width: 100%" >
    
      <!-- <el-table-column fixed prop="id" label="id" width="120" align="center">
      </el-table-column>  -->
      <el-table-column fixed prop="robotId" label="robotId" width="120" align="center">
      </el-table-column> 
       <el-table-column   label="交易对"  align="center">
        <template slot-scope="scope">
          {{scope.row.symbolList.join(' , ')}}
        </template>
      </el-table-column>
    
     
      <el-table-column label="操作"   fixed="right" width="120"  align="center">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary" 
            circle
            icon="el-icon-edit"
            @click="handleEdit(scope.$index, scope.row)"
          ></el-button>
          <el-button
            size="small"
            type="danger"
            circle
            icon="el-icon-delete"
            @click="handleDelete(scope.$index, scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 编辑机器人交易对信息 -->
    <el-dialog
      title="修改机器人交易对配置信息"
      width="800px"
      :visible.sync="dialogVisibleChange"
      @close="closeDialog"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="260px"
        class="demo-ruleForm"
      >
        <el-form-item label="交易对" prop="symbolList">
          <el-select v-model="value1" multiple filterable  placeholder="请选择机器人交易对">
            <el-option
              v-for="item in pairData"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="id" prop="id">
          <el-input v-model="id" disabled></el-input>
        </el-form-item> -->
        <span slot="footer" class="dialog-footer"> </span>
        <el-form-item label-width="240px">
          <el-button type="primary" @click="updateRobotInfo('ruleForm')"
            >确定修改</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    
  </div>
</template>

<script>
import { CollapseItem } from "element-ui";
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
export default {
  name: "CreateContent",
  // props: ["page", "size", "totalCount"],
  data() {
    return {
      dialogVisibleChange: false,
      dialogSwitch: false,
      innerVisible: false,
      front:'',
      delayName: "",
      parameter: "",
      pair: "",
      addPair: "",
      value1:[],
      ruleForm:{},
      updateId:'',
    
   
    };
  },
  mounted() {
    this.getData();
    this.getPairData()
  },
  computed: {
    ...mapState("RobotPairConfig", ["robotlist",'pairData']),
    frontStr(){
      return this.robotlist.frontCoinAmount+this.robotlist.fbsPair.split("_")[0]
    }
  },
  methods: {
    ...mapActions("RobotPairConfig", [
      'getList','getPairData','updateOne',
      "getlist",
      "delOne",
      "updateInfo",
      "getSwitchObjData",
      "asyncUpdateRobotPiar",
      "asyncUpdateRobotSwitch",
      "asyncDelOneRobotSwitch",
      "asyncAddRobotSwitch",
    ]),
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
    async getData() {
      const res=await this.getList({ robotId: "", page: 1, size: 10 })
      // const res = await this.getlist({ pair: "", page: 1, size: 10 });
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await this.delOne(row.id);
          if (res.code == 0) {
            this.$message.success("操作成功");
            this.getData();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleEdit(index, row) {
      this.dialogVisibleChange = true;
     this.updateId = row.id;
      this.ruleForm = { ...row };
      this.value1=[...this.ruleForm.symbolList]
    },

    async updateRobotInfo() {
      const obj={id:this.ruleForm.id,robotId:this.ruleForm.robotId,symbolList:[...this.value1]}
      const res = await this.updateOne(obj);
      if (res.code == 0) {
        this.getData();
        this.$message.success("修改成功");
        this.dialogVisibleChange = false;
      }
    },
   
   
    open() {
      this.innerVisible = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.value1=[]
    },
    closeDialog() {},
  },
};
</script>

<style lang="less" scoped>
.el-form-item__content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .el-button {
    margin-left: 40px;
  }
  .el-switch {
    margin-left: 40px;
  }
  .el-input {
    display: inline-block;
    width: 300px;
  }
}
</style>
